import { useCoreDispatch, useCoreSelector } from "../../redux/config.js";
import { selectBuild } from "../../redux/build/selectors.js";
import { getBuild } from "../../redux/build/thunks/get-build.js";
import { useCallback, useEffect } from "react";
//#region src/presentation/hooks/use-build.ts
var useBuild = () => {
	const dispatch = useCoreDispatch();
	const build = useCoreSelector(selectBuild());
	const fetchBuild = useCallback(async () => {
		if (!build) await dispatch(getBuild());
	}, [build]);
	useEffect(() => {
		fetchBuild();
	}, [fetchBuild]);
	return build;
};
//#endregion
export { useBuild };

//# sourceMappingURL=use-build.js.map